import { SET_CATEGORYLIST } from '../actions';

const categorylist = (state = [], action) => {
  switch (action.type) {
	case SET_CATEGORYLIST:
      return [...action.value];  
    default: return state;
  }
}

export default categorylist;
